(() => {
  'use strict';

  const initCounters = (root = document) => {
    root.querySelectorAll('[data-gnw-personalization]').forEach((container) => {
      if (container.dataset.gnwCounterReady === 'true') return;
      const input = container.querySelector('[data-gnw-personalization-text]');
      const counter = container.querySelector('[data-gnw-char-counter]');
      if (!input || !counter) return;

      const update = () => {
        counter.textContent = `${input.value.length} / ${input.maxLength} Zeichen`;
      };

      input.addEventListener('input', update);
      update();
      container.dataset.gnwCounterReady = 'true';
    });
  };

  const initStickyAtc = () => {
    const bar = document.querySelector('[data-gnw-sticky-atc]');
    if (!bar || bar.dataset.gnwReady === 'true') return;

    const standardForm = document.querySelector('.product-single__form');
    const flexForm = document.querySelector('product-form > form');
    const form = standardForm || flexForm;
    if (!form) return;

    const mainButton = form.querySelector('[data-add-to-cart], button[name="add"], button[type="submit"], input[type="submit"]');
    const stickyButton = bar.querySelector('[data-gnw-sticky-submit]');
    const stickyPrice = bar.querySelector('[data-gnw-sticky-price]');
    if (!mainButton || !stickyButton) return;

    const syncDisabled = () => {
      stickyButton.disabled = !!mainButton.disabled;
      stickyButton.textContent = mainButton.disabled ? 'Nicht verfügbar' : 'In den Warenkorb';
    };

    const setVisible = (visible) => {
      if (window.matchMedia('(min-width: 990px)').matches) visible = false;
      bar.hidden = !visible;
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle('gnw-sticky-atc-visible', visible);
    };

    stickyButton.addEventListener('click', () => {
      syncDisabled();
      if (!stickyButton.disabled) mainButton.click();
    });

    const buttonObserver = new MutationObserver(syncDisabled);
    buttonObserver.observe(mainButton, { attributes: true, attributeFilter: ['disabled', 'class'] });
    syncDisabled();

    if ('IntersectionObserver' in window) {
      const visibilityObserver = new IntersectionObserver((entries) => {
        setVisible(!entries[0].isIntersecting);
      }, { threshold: 0.01 });
      visibilityObserver.observe(mainButton);
    }

    document.addEventListener('variant:change', (event) => {
      const variant = event.detail && event.detail.variant;
      if (variant && stickyPrice && window.theme && theme.Currency && theme.settings) {
        stickyPrice.textContent = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
      }
      window.requestAnimationFrame(syncDisabled);
    });

    window.addEventListener('resize', () => {
      if (window.matchMedia('(min-width: 990px)').matches) setVisible(false);
    }, { passive: true });

    bar.dataset.gnwReady = 'true';
  };

  const init = () => {
    initCounters();
    initStickyAtc();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initCounters(event.target || document);
    initStickyAtc();
  });
})();
